import { Box, Button, Grid } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";

import { Amount } from "../../../../components/amount";
import { Async } from "../../../../components/Async";
import { ListTable } from "../../../../components/list_table";
import { QUERY_KEYS } from "../../../../constants";
import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { IClient } from "../../data/entities";
import { ClientRepoImpl } from "../../data/repo";
import { calcClientListSummary } from "../utils";

export const ClientListPage: React.FC = () => {
  const asyncClientList = useQuery(QUERY_KEYS.clientList, () => ClientRepoImpl.getList());

  return (
    <div>
      <Box py={3}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          to={Routing.generateCreateRoute(ROUTES.client)}
          component={Link}
        >
          Yarat
        </Button>

        <Box pl={5} component="span">
          <Button to={ROUTES.clientHistory} component={Link}>
            Tarixçə
          </Button>
        </Box>
      </Box>

      <Async
        asyncData={asyncClientList}
        renderSuccess={(clientList) => {
          const clientsWithDebt = clientList.filter((c) => c.balance < 0) ?? [];
          const clientsWithoutDebt = clientList.filter((c) => c.balance >= 0) ?? [];

          return (
            <Grid container spacing={2}>
              <Grid item sm={12} md={6}>
                <ListTable<IClient>
                  branch={clientsWithDebt}
                  route={ROUTES.client}
                  canEdit
                  renderHeader={() => (
                    <>
                      <TableCell>Ad</TableCell>
                      <TableCell>Balans</TableCell>
                      <TableCell>Maaş</TableCell>
                    </>
                  )}
                  renderRow={(client) => (
                    <>
                      <TableCell>{client.name}</TableCell>
                      <TableCell>
                        <Amount amount={client.balance} />
                      </TableCell>
                      <TableCell>{client.salary} AZN</TableCell>
                    </>
                  )}
                  renderSummary={() => {
                    const total = calcClientListSummary(clientsWithDebt);

                    return (
                      <>
                        <TableCell colSpan={2}>Toplam</TableCell>
                        <TableCell colSpan={3}>
                          <Amount amount={total} />
                        </TableCell>
                      </>
                    );
                  }}
                />
              </Grid>

              <Grid item sm={12} md={6}>
                <ListTable<IClient>
                  branch={clientsWithoutDebt}
                  route={ROUTES.client}
                  canEdit
                  renderHeader={() => (
                    <>
                      <TableCell>Ad</TableCell>
                      <TableCell>Balans</TableCell>
                      <TableCell>Maaş</TableCell>
                    </>
                  )}
                  renderRow={(client) => (
                    <>
                      <TableCell>{client.name}</TableCell>
                      <TableCell>
                        <Amount amount={client.balance} />
                      </TableCell>
                      <TableCell>{client.salary} AZN</TableCell>
                    </>
                  )}
                  renderSummary={() => {
                    const total = calcClientListSummary(clientsWithoutDebt);

                    return (
                      <>
                        <TableCell colSpan={2}>Toplam</TableCell>
                        <TableCell colSpan={3}>
                          <Amount amount={total} />
                        </TableCell>
                      </>
                    );
                  }}
                />
              </Grid>
            </Grid>
          );
        }}
      />
    </div>
  );
};
